import {Map} from 'immutable'

import {SET_NEW_MESSAGE_NOTIFICATIONS} from '../action_types'

import messageNotificationsReducer from './message_notifications'

export default (state = Map({}), action) => {
  switch (action.type) {
    case SET_NEW_MESSAGE_NOTIFICATIONS:
      return state.set(
        'messages',
        messageNotificationsReducer(state.get('messages'), action)
      )

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/notifications.js
 **/